import React from "react";
import { useSSelector } from "../util";
import useWindowSize from "./hooks/useWindowSize";

export const MapAdvertismentView = () => {
  const { width, height } = useWindowSize();
  const activeUser = useSSelector((state) => state.activeUser);
  if (activeUser.state === "fetching" || activeUser.account?.features?.pro) {
    return <></>;
  }

  return (
    <div id="advertisement">
      {width > 768 ? (
        <a
          href="https://servedbyadbutler.com/go2/;ID=186857;size=390x260;setID=709787"
          target="_blank"
        >
          <img
            src="https://servedbyadbutler.com/adserve/;ID=186857;size=390x260;setID=709787;type=img;click=CLICK_MACRO_PLACEHOLDER"
            width="390"
            height="260"
          />
        </a>
      ) : (
        <a
          href="https://servedbyadbutler.com/go2/;ID=186857;size=390x100;setID=709789"
          target="_blank"
        >
          <img
            src="https://servedbyadbutler.com/adserve/;ID=186857;size=390x100;setID=709789;type=img;click=CLICK_MACRO_PLACEHOLDER"
            width="390"
            height="100"
          />
        </a>
      )}
    </div>
  );
};
